"use client";

import React from "react";
import { ArrowRight, Phone, ShieldCheck, DollarSign, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [{
    icon: <DollarSign className="size-5 text-primary" />,
    text: "Top Dollar Paid"
  }, {
    icon: <Clock className="size-5 text-primary" />,
    text: "Fast & Easy Process"
  }, {
    icon: <ShieldCheck className="size-5 text-primary" />,
    text: "Trusted Local Buyer"
  }];
  return <section id="hero" className="relative w-full min-h-[85vh] flex items-center justify-center overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/albany_scrap_cars_hero_bg.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/albany_scrap_cars_hero_bg.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660796/img/albany_scrap_cars_hero_bg.png-wvc-sizes" alt="Professional car buying service in Albany" className="w-full h-full object-cover object-center" loading="eager" />
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background/95 via-background/80 to-background/40 backdrop-blur-[2px]"></div>
      </div>

      {}
      <div className="container relative z-10 px-4 md:px-6 py-20 md:py-32 mx-auto">
        <div ref={contentRef} className={`max-w-3xl transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 text-primary font-medium text-sm mb-6 border border-primary/20 shadow-sm">
            <span className="relative flex size-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
              <span className="relative inline-flex rounded-full size-2 bg-primary"></span>
            </span>
            Serving Albany, NY & Surrounding Areas
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold font-default text-foreground tracking-tight leading-[1.1] mb-6">
            Sell Your Car to Albany's <span className="text-primary">Trusted Buyer</span>
          </h1>

          <p className="text-lg md:text-xl text-foreground/80 max-w-2xl mb-10 font-default leading-relaxed">
            Get the best price for your scrap, junk, or used cars in Albany, NY. 
            We offer a fast, easy, and hassle-free process with instant cash offers and free towing.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <Button size="lg" className="h-14 px-8 text-lg shadow-lg shadow-primary/20" asChild>
              <Link to="#vehicle-appraisal-form">
                Get a Free Quote
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
            <Button size="lg" variant="outline" className="h-14 px-8 text-lg bg-background/80 backdrop-blur-md border-border hover:bg-accent" asChild>
              <Link to="tel:+15185550198"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-phone mr-2 size-5" aria-hidden="true" data-ast-id="f:/src/pages/SellMyCar/sections/Hero.tsx|sig:p31aj8" data-ast-start="3729" data-ast-end="3762"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg>Call (518) 459-3404</Link>
            </Button>
          </div>

          {}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-8 border-t border-border/50">
            {features.map((feature, i) => <div key={i} data-index={i} className="flex items-center gap-3">
                <div className="flex items-center justify-center size-10 rounded-full bg-background shadow-sm border border-border/50">
                  {feature.icon}
                </div>
                <span className="font-medium text-foreground font-default">
                  {feature.text}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}